const tileLabels = {
    LIVE_SOON: 'browseui_tileStatusLiveSoon',
    LIVE: 'browseui_tileStatusLive',
    AGE_RESTRICTION: 'YouthProtection_VerificationRCC_header',
    NEW: 'NewLabel'
};

const labelTypes = {
    LIVE: 'LIVE',
    LIVE_SOON: 'LIVE_SOON',
    FREETOVIEW: 'FREETOVIEW',
    NEW: 'NEW',
    PAY_PER_VIEW_SUBSCRIBE: 'PAY_PER_VIEW_SUBSCRIBE',
    NONE: 'NONE',
    DATE: 'DATE'
};

const tileMetadata = {
    HIGHLIGHTS_ONLY: 'browseui_tileHighlightsOnly',
    AMERICAN_FOOTBALL_CONDENSED: 'browseui_tile_american_football_condensed',
    AMERICAN_FOOTBALL_GAME_IN_40: 'browseui_AmericanFootballGameIn40',
    CONDENSED: 'player_videotypes_condensed',
    HIGHLIGHTS: 'player_videotypes_highlights',
    FIBA_THREE_MINUTES_HIGHLIGHTS:
        'browseui_tile_fiba_three_minutes_highlights',
    FIBA_TEN_MINUTES_HIGHLIGHTS: 'browseui_tile_fiba_ten_minutes_highlights'
};

const tileStatus = {
    LIVE_SOON: 'LiveSoon',
    EMBARGOED: 'Embargoed'
};

const tileTypes = {
    CONDENSED: 'Condensed',
    AMERICAN_FOOTBALL_CONDENSED: 'AmericanFootballCondensed',
    AMERICAN_FOOTBALL_GAME_IN_40: 'AmericanFootballGameIn40',
    COACHES: 'Coaches',
    CATCH_UP: 'CatchUp',
    HIGHLIGHTS: 'Highlights',
    LIVE: 'Live',
    UPCOMING: 'UpComing',
    ON_DEMAND: 'OnDemand',
    NAVIGATION: 'Navigation',
    CONTENT: 'Content',
    TEXT: 'Text',
    SKELETON: 'Skeleton',
    NEWS: 'News',
    SHOW: 'Show',
    FIBA_THREE_MINUTES_HIGHLIGHTS: 'Courtside3MinHighlights',
    FIBA_TEN_MINUTES_HIGHLIGHTS: 'Courtside10MinHighlights'
};

export {tileLabels, labelTypes, tileMetadata, tileStatus, tileTypes};
